import React, { useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { formatPrice } from '../components/capitalizeFunction';
import LoadingSpiner from '../components/LoadingSpiner';
import { useRapportMonth } from '../../Api/queriesRapport';

/**
 * Rapport mensuel (mois 0–11, toutes les années) — optimisation :
 * avant : trois useAll* + getMonth() côté client.
 * maintenant : GET /api/rapport/month ($month Mongo en UTC, comme le reste des agrégations).
 */
const SelectedMounthTotalResult = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  const { data: rapport, isLoading, error } = useRapportMonth(selectedMonth);

  const monthOptions = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];

  const totalCommandesNumber = rapport?.commandeCount ?? 0;
  const totalPaiementsToPaye = rapport?.totalPaiementsToPaye ?? 0;
  const totalPaiementsAmountPaye = rapport?.totalPaiementsAmountPaye ?? 0;
  const totalPaiementsNotPaye =
    totalPaiementsToPaye - totalPaiementsAmountPaye || 0;
  const totalDepenses = rapport?.totalDepenses ?? 0;
  const totalAchat = rapport?.totalAchat ?? 0;
  const benefice = rapport?.benefice ?? 0;

  return (
    <React.Fragment>
      <Card style={{ boxShadow: '0px 0px 10px rgba(123, 123, 123, 0.28)' }}>
        {/* Filtrage Bouton */}
        <Row>
          <Col md={4}>
            <Card
              style={{
                background: 'linear-gradient(1deg, #ff0099, #493240)',
              }}
            >
              <CardBody>
                <h6 className='text-white text-center'>Sélectionnez un Mois</h6>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <select
                    className='form-select form-select-sm'
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                  >
                    {monthOptions.map((label, index) => (
                      <option key={index} value={index}>
                        {label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='text-center text-white'></div>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <h4 className='text-center mt-5' style={{ color: ' #BE5B50' }}>
              Rapports Mensuel
            </h4>
          </Col>
        </Row>

        {error && (
          <div className='text-danger text-center px-3'>
            Erreur de chargement du rapport
          </div>
        )}
        {isLoading && <LoadingSpiner />}

        {/* Résultats */}
        <Row>
          {/* Bénefices */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #0d1b2a',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <h5 className='mb-1 text-white'>Bénéfice</h5>
              {benefice <= 0 ? (
                <h4 className='text-danger'>{formatPrice(benefice)} F</h4>
              ) : (
                <h4 className='text-success'>{formatPrice(benefice)} F</h4>
              )}
            </Card>{' '}
          </Col>
          {/* Paiements */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #1b263b',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <p className='text-white'>
                Revenue (Chiffre d'Affaire)
                <i
                  className='fas fa-level-down-alt ms-2 fs-4'
                  style={{ color: '#B6F500' }}
                ></i>
              </p>
              <h4 className='mb-1' style={{ color: ' #B6F500' }}>
                {formatPrice(totalPaiementsAmountPaye)} F
              </h4>
            </Card>{' '}
          </Col>
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #415a77',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <p className='text-white'>Achat sur Revenue</p>
              <h4 className='mb-1' style={{ color: '#B6F500' }}>
                {formatPrice(totalAchat)} F
              </h4>
            </Card>{' '}
          </Col>

          {/* Dépences */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #778da9',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <p className='text-white'>
                Dépenses
                <i
                  className='fas fa-level-up-alt ms-2 fs-4'
                  style={{ color: '#901E3E' }}
                ></i>
              </p>
              <h4 className='mb-1' style={{ color: '#901E3E' }}>
                {formatPrice(totalDepenses)} F
              </h4>
            </Card>{' '}
          </Col>

          {/* Commandes */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #0077b6',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <p className='text-white'>Commandes</p>
              <h5 className='text-warning my-1'>{totalCommandesNumber}</h5>
            </Card>{' '}
          </Col>
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #03045e',
                justifyContent: 'center',
                alignItems: 'start',
                height: '100px',
                padding: '0px 10px',
              }}
            >
              <h5 className='my-1 text-light'>
                Total À Payé:{' '}
                <span className='text-light ps-3'>
                  {' '}
                  {formatPrice(totalPaiementsToPaye)} F
                </span>
              </h5>
              <h5 className='my-1 text-light'>
                Net Payé:{' '}
                <span className='text-success ps-3'>
                  {' '}
                  {formatPrice(totalPaiementsAmountPaye)} F
                </span>
              </h5>
              <h5 className='my-1 text-light'>
                Impayé:{' '}
                <span className='text-danger ps-3'>
                  {' '}
                  {formatPrice(totalPaiementsNotPaye)} F
                </span>
              </h5>
            </Card>
          </Col>
        </Row>
      </Card>
    </React.Fragment>
  );
};

export default SelectedMounthTotalResult;
